import React from 'react'

const ErrorMessage = ({ message }) => {
  return (
    <div className="tf-container tf-spacing-1 py-5">
      <div className="error-404 text-center">
        <h1 className="mb-20 title">Oh no... {message}</h1>
        <p className="mb-40">We searched everywhere but couldn’t find what you’re looking for. Let’s find <br /> a
          better place for you to go.
        </p>
        <a href="../properties" className="tf-btn bg-color-primary rounded-4 pd-3 fw-6 mx-auto">Back to properties</a>
      </div>
    </div>
  )
}

export default ErrorMessage